export enum SignDocumentRouteNames {
  SIGN_DOCUMENT_TABLE = "DocumentTableView",
  SIGN_DOCUMENT_DETAIL = "SignDocumentDetailView",
  SIGN_REQUEST_TABLE = "SIGN_REQUEST_TABLE",
  SIGN_REQUEST_DETAIL = "SignRequestDetailView"
}
